import React from 'react';
import { MessageCircle, ExternalLink } from 'lucide-react';
import { Button } from './ui/neon-button';
import { useTranslation } from 'react-i18next';

const CTA = () => {
  const { t } = useTranslation();

  const handleBuyClick = () => {
    window.open('https://220.lv/ru/magazin/exodus', '_blank', 'noopener,noreferrer');
  };

  const handleChatClick = () => {
    if (window.voiceflow?.chat?.open) {
      window.voiceflow.chat.open();
    }
  };

  return (
    <section id="where-to-buy" className="py-24 bg-[#1E3A8A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('cta.title')}
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto">
            {t('cta.description')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <div className="bg-white rounded-xl p-8 text-center hover:shadow-xl transition-shadow duration-300">
            <MessageCircle className="w-12 h-12 text-[#1E3A8A] mx-auto mb-4" />
            <h3 className="text-xl font-bold text-[#222222] mb-3">
              {t('cta.chat.title')}
            </h3>
            <p className="text-[#555555] mb-6">
              {t('cta.chat.description')}
            </p>
            <Button 
              variant="solid" 
              size="lg" 
              className="inline-flex items-center"
              onClick={handleChatClick}
            >
              {t('cta.chat.button')}
              <MessageCircle className="ml-2 w-5 h-5" />
            </Button>
          </div>

          <div className="bg-white rounded-xl p-8 text-center hover:shadow-xl transition-shadow duration-300">
            <ExternalLink className="w-12 h-12 text-[#1E3A8A] mx-auto mb-4" />
            <h3 className="text-xl font-bold text-[#222222] mb-3">
              {t('cta.buy.title')}
            </h3>
            <p className="text-[#555555] mb-6">
              {t('cta.buy.description')}
            </p>
            <Button 
              variant="solid" 
              size="lg" 
              className="inline-flex items-center"
              onClick={handleBuyClick}
            >
              {t('cta.buy.button')}
              <ExternalLink className="ml-2 w-5 h-5" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;